import { useMemo, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import AdminPostSearchModule from './AdminPostSearchModule'
import AdminSinglePost from './AdminSinglePost'
import Spinner from '../components/Spinner'
import classes from './adminBetPortal.module.css'

const AdminBetPortal = ({ type = 'bet_portal' }) => {
  const [isArray, setIsArray] = useState(false)
  const navigate = useNavigate()
  const axiosPrivate = useAxiosPrivate()
  const [searchInput, setSearchInput] = useState('')

  const getAllBetPortalPosts = async () => {
    const enumType = type === 'bet_portal' ? 'betportals' : 'leagues'
    const { data } = await axiosPrivate.get(
      `/getAllBetPortalPosts?type=${enumType}`
    )
    const isArray = await Array.isArray(data.result)
    if (isArray) {
      setIsArray(true)
    }

    return data
  }
  const allBetPortalPostsQuery = useQuery({
    queryKey: ['BetPortalPosts', type],
    queryFn: getAllBetPortalPosts,
    staleTime: 0,
    refetchInterval: 1000 * 60 * 60 * 12,
  })

  const filteredResults = useMemo(() => {
    if (!allBetPortalPostsQuery?.data?.result) return []

    return allBetPortalPostsQuery.data.result.filter((item) =>
      item.title.toLowerCase().includes(searchInput.toLowerCase())
    )
  }, [allBetPortalPostsQuery.data?.result, searchInput])

  if (allBetPortalPostsQuery.isError) return <h2>Error...</h2>

  const handleNewPost = () => {
    navigate('/betko-admin/kreiraj-novi-post', {
      state: type,
    })
  }

  return (
    <div className={classes.container}>
      {allBetPortalPostsQuery.isLoading ? (
        <Spinner />
      ) : (
        <>
          <h1>{type === 'bet_portal' ? 'BET PORTAL' : 'LIGE I IZAZOVI'}</h1>
          <div className={classes.top}>
            {isArray && allBetPortalPostsQuery.data.result !== undefined && (
              <input
                className={classes.input}
                type='text'
                placeholder='Upiši naslov'
                onChange={(e) => setSearchInput(e.target.value)}
                value={searchInput}
              />
            )}
            <button onClick={() => handleNewPost()} className={classes.btn}>
              Dodaj Novi
            </button>
          </div>
          <div className={classes.postContainer}>
            <div>
              {isArray
                ? filteredResults.map((post) => {
                    return (
                      <AdminSinglePost post={post} key={post._id} type={type} />
                    )
                  })
                : allBetPortalPostsQuery.data.msg}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default AdminBetPortal
